import React from "react";

export function Button({ onClick, wait, label, ...props }) {
  return (
    <button className="btn btn--primary" disabled={wait} {...props}>
      {wait ? "Please wait..." : label}
    </button>
  );
}
